/***
 *
 *   HOME NAV
 *   Navigation used on the main external website. Renders a dashboard link
 *   if the user is signed in, or a sign up link if they are not
 *
 **********/

import { Fragment, useContext } from 'react';
import { AuthContext, Content, ClassHelper, useNavigate, useLocation } from 'components/lib';
import Style from './home.tailwind.js';
import { UMButton } from '@urbanmetrix/um-kit';

interface HomeNavProps {
  transparent?: boolean;
}

export function HomeNav(props: HomeNavProps) {
  // context
  const context = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  const path = location.pathname || '';
  const isTermsPage = path === '/terms';
  const isMaintenancePage = path === '/maintenance';

  const css = ClassHelper(Style, {
    wrapper: true,
    color: !props.transparent,
    transparent: props.transparent,
  });

  return (
    <section className={`${css} ${isTermsPage ? '' : 'home-header'}`}>
      <Content>
        <nav className={Style.nav}>
          {path === '/terms' ? (
            <UMButton small onClick={() => navigate('/login?view=register')} text="X" />
          ) : context.isAuthenticated ? (
            <></>
          ) : isMaintenancePage ? null : (
            <Fragment>
              <UMButton
                style={{ marginRight: 1 }}
                small
                onClick={() => navigate('/login')}
                text="Login"
                disabled={path.startsWith('/login')}
              />
              <UMButton
                small
                onClick={() => navigate('/login?view=register')}
                text="Register"
                disabled={path === '/login' && location.search === '?view=register'}
                // className='inline-block'
              />
            </Fragment>
          )}
        </nav>
      </Content>
    </section>
  );
}
